var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-detail" },
    [
      _c("codemirror", {
        staticClass: "file-content",
        attrs: { options: _vm.options },
        model: {
          value: _vm.fileContent,
          callback: function($$v) {
            _vm.fileContent = $$v
          },
          expression: "fileContent"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }